module.exports = __webpack_public_path__ + "img/k.a1cda938.jpg";